import React from 'react'
import { GreenCheckIcon, OrangeCircleIcon } from '../../../../../Component/Icons'
import { formatter } from '../../../../../Helper/Money'

export interface EnhancedDataTotalRowProps {
  total: number
  hasMatchingTotals: boolean
  emptyColSpan?: number
}

export function EnhancedDataTotalRow (props: EnhancedDataTotalRowProps): React.JSX.Element {
  const { total, emptyColSpan = 4, hasMatchingTotals } = props
  const maxColSpan = 7
  const reservedColSpan = maxColSpan - emptyColSpan

  const formattedTotal = formatter.format(total)

  const getTotalMatchIcon = () : React.JSX.Element => {
    switch (hasMatchingTotals) {
      case true:
        return <GreenCheckIcon/>
      case false:
        return <OrangeCircleIcon/>
    }
  }

  return (
    <tr className="ed-total-row">
      <td colSpan={emptyColSpan} ></td>
      <td colSpan={reservedColSpan} className="ed-total-cell">
        <div className="ed-total-container">
          <div className="ed-total-right">
            <span className="ed-total-label">
              Enhanced Data Total &nbsp;
              { getTotalMatchIcon() }
            </span>
            <span className="ed-total-amount">{formattedTotal}</span>
          </div>
        </div>
      </td>
    </tr>
  )
}
